import { render, staticRenderFns } from "./change_password.vue?vue&type=template&id=96d832fa&scoped=true&style=padding-left%3A100px%3B&"
import script from "./change_password.vue?vue&type=script&lang=js&"
export * from "./change_password.vue?vue&type=script&lang=js&"
import style0 from "./change_password.vue?vue&type=style&index=0&id=96d832fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d832fa",
  null
  
)

export default component.exports